export default {
  title: 'Join {{name}}!',
  default_program_name: 'Rewards Club',
  benefits: {
    earn_points: 'Earn points with every order',
    get_deals: 'Receive exclusive discounts',
    redeem_points: 'Redeem points for free food',
  },
  terms: 'By signing up, you&apos;ll receive email and text offers from our&nbsp;',
  buttons: {
    log_in: 'Log In',
    sign_up: 'Sign Up',
  },
  labels: {
    already_have_account: 'Already have an account?',
  },
  signup_note:
    "By signing up, you'll receive email and text offers from our <0>restaurant</0> and <1>FoodAmigos</1>, our technology partner. You agree to our <2>Platform Terms</2> and <3>Privacy Policy</3>.",
};
